import { useCallback } from "react";
import { Address } from "../../../../../model/Address";
import {
  AddressFormElement,
  AddressFormElementExecution,
} from "../../../types";
import TaskFormAddressComponent from "../../task-types/form/TaskFormAddressComponent";
import { useFormBuilderContext } from "../FormBuilderProvider";

export const AddressInlineDisplay = ({
  element,
  executionData,
}: {
  element: AddressFormElement;
  executionData?: AddressFormElementExecution;
}) => {
  const { onFormElementChange } = useFormBuilderContext();
  const onValueChange = useCallback(
    (value: Address) => {
      if (value.zip_code == 0) {
        const newExecutionData: AddressFormElementExecution = {
          ...(executionData ?? {
            id: element.id,
            name: element.name,
            label: element.label,
          }),
          value: undefined,
        };
        if (value !== executionData?.value) {
          onFormElementChange({
            changeType: "update",
            newExecutionData,
          });
        }
        return;
      }

      const newExecutionData: AddressFormElementExecution = {
        ...(executionData ?? {
          id: element.id,
          name: element.name,
          label: element.label,
        }),
        value: value,
      };
      if (value !== executionData?.value) {
        onFormElementChange({
          changeType: "update",
          newExecutionData,
        });
      }
    },
    [
      element.id,
      element.label,
      element.name,
      executionData,
      onFormElementChange,
    ],
  );

  return (
    <TaskFormAddressComponent
      disabled={true}
      onValueChange={onValueChange}
      execution={executionData}
      {...element}
    />
  );
};
